jQuery(function ($) {

	var cookie_register_reminder = "crecer_rg_reminder"
  /*
  * Mostrar popup publicitario para que el usuario se registre
  */
  if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		setTimeout(function(){		
			if( rgGetCookie(cookie_register_reminder) != 1) {
				$("#popup-suscribe").slideDown( "slow" );
			}			
	  }, 1000) 
  }

	//Ocultar el popup publicatario de registro y crear cookie para no mostrarlo mas en 30 dias
	$("#popup-suscribe a").on("click", function() {
		$("#popup-suscribe").css("display", "none");
		rgSetCookie(cookie_register_reminder, 1, 30)
	})

	function rgSetCookie(cname, cvalue, exdays) {
	  var d = new Date();
	  d.setTime(d.getTime() + (exdays*24*60*60*1000));
	  var expires = "expires="+ d.toUTCString();
	  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}  

	function rgGetCookie(cname) {
	  var name = cname + "=";
	  var decodedCookie = decodeURIComponent(document.cookie);
	  var ca = decodedCookie.split(';');
	  for(var i = 0; i <ca.length; i++) {
	    var c = ca[i];
	    while (c.charAt(0) == ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) == 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return "";
	}

	$("#user-name, .close-sidebar").on("click", function() {
		toggleUserSideBar();		
		$("#navbar").toggleClass("show");
	})

	//Funcion para mostrar/ocultar la barra derecha del usuario
	function toggleUserSideBar() {
		$(".user-sidebar").toggleClass("show");
		$(".right-sidevar-wrapper").toggle();

		loadFavoritesPost();
	}

	$("#go_to_topics_tab").on("click", function() {
		$('#userSidebarTab li:last-child button').tab('show') // Select last tab
	})

	$('form[name="user_topics_form"]').on("submit", function() {
		save_user_topics($(this));
		return false;
	})
	function save_user_topics(form) {

		//Si no existen datos de usuario
		if(typeof(user_params) === "undefined") {
			return;
		}

		const user_id  = user_params['user_id']
		const user_key = user_params['user_key']

		var submit_button = $(form).find('input[type="submit"]')

		var postData = $(form).serialize();
		postData = postData + "&user_id="+user_id;
		postData = postData + "&user_key="+user_key;
		
		var baseUrl = $("#site_url").val();
		var userTopicsEndpoint = baseUrl + "wp-json/module-user/v1/set-user-topics/";
    $.ajax({
      url 			: userTopicsEndpoint,
      dataType 	: 'json',
      type 			: "POST",
      data 			: postData,

      beforeSend : function(xhr) {
        submit_button.hide();
        submit_button.parent().find(".form-submit-loading").show()
      },
      success:function(data) {
      	submit_button.show();
      	submit_button.parent().find(".form-submit-loading").hide()

      	//Actualizar la variable de control de contenido de usuario sugerido para que cargue los nuevos contenidos
      	user_content_params['suggested_post_status'] = "not_loaded";
      	//Cargar los contenidos sugeridos
      	loadSuggestedPost();
      }
    });
	}

	$('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
		if($(e.target).attr('data-bs-target') == "#suggested-tab-pane") {
			loadSuggestedPost();
		} else if($(e.target).attr('data-bs-target') == "#favorites-tab-pane") {
			loadFavoritesPost();
		}

	})
	function loadSuggestedPost() {
		
		//Continuar solo si no se ha cargado el contenido
		//user_content_params['suggested_post_status'] controla que no se hagan llamados al back sin necesidad
		if(user_content_params['suggested_post_status'] != "not_loaded") {
			return;
		}

		var data = "action=user_suggested_post";
		$.ajax({
			url: 	"/wp-admin/admin-ajax.php",
			data: data,
			type: 'GET',
			beforeSend: function( xhr ){
			},
			success:function(response){
				const data = JSON.parse(response)
				$("#post-suggested-list").html(data['content']);
				user_content_params['suggested_post_status'] = "loaded";

				if(data['has_results']) {
					$("#go_to_topics_tab").hide();
				} else {
					$("#go_to_topics_tab").show();
				}
			}
		});
	}

	function loadFavoritesPost() {
		
		//Continuar solo si no se ha cargado el contenido
		//user_content_params['favorites_post_status'] controla que no se hagan llamados al back sin necesidad
		if(user_content_params['favorites_post_status'] != "not_loaded") {
			return;
		}

		var data = "action=user_favorites_post";
		$.ajax({
			url: 	"/wp-admin/admin-ajax.php",
			data: data,
			type: 'GET',
			beforeSend: function( xhr ){
			},
			success:function(response){
				const data = JSON.parse(response)
				$("#post-favorites-list").html(data['content']);
				user_content_params['favorites_post_status'] = "loaded";

				if(data['has_results']) {
					$("#view-all-favorites").show();
				} else {
					$("#view-all-favorites").hide();					
				}
			}
		});
	}
});